import { Component, inject, OnInit, signal } from '@angular/core';
import { FeedbackViewComponent } from '../feedback-view/feedback-view.component';
import { FeedbackService } from 'src/app/services/feedback.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfirmedFeedbackComponent } from 'src/app/components/confirmed-feedback/confirmed-feedback.component';
import { ErrorComponentComponent } from 'src/app/components/error-component/error-component.component';

@Component({
  selector: 'app-feedback',
  imports: [
    FeedbackViewComponent,
    MatProgressSpinnerModule,
    ConfirmedFeedbackComponent,
    ErrorComponentComponent,
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss',
})
export class FeedbackComponent implements OnInit {
  ngOnInit(): void {
    this.loadDataCaseToken();
    this.getCaseStatus();
  }

  private feedbackService = inject(FeedbackService);
  public caseToken = signal<string>('');
  public feedbackSent = signal<boolean>(false);
  private snackBar = inject(MatSnackBar);
  private activateRoute = inject(ActivatedRoute);
  private router = inject(Router);
  isLoading = signal<boolean>(true);
  showRatingForm = signal<boolean>(false);

  public errorMessage = signal<string>('');

  caseStatus: boolean;

  onSubmitFeedback(feedback: any) {
    this.isLoading.set(true);
    this.feedbackService
      .submitFeedback(this.caseToken(), feedback)
      .pipe(
        tap(() => {
          this.feedbackSent.set(true);
          this.isLoading.set(false);
        }),
        catchError(err => {
          this.feedbackSent.set(false);
          this.isLoading.set(false);
          this.snackBar.open(
            'Failed to send feedback. Please try again.',
            'Close',
            {
              duration: 4000,
              panelClass: ['snackbar-error'],
            }
          );
          return of(null);
        })
      )
      .subscribe();
  }

  private loadDataCaseToken(): void {
    const token = this.activateRoute.snapshot.queryParamMap.get('caseToken');

    if (token) {
      this.caseToken.set(token);
      this.feedbackService.setCaseToken(token);
    } else {
      this.caseToken.set('');
      this.router.navigate(['/error'], {
        queryParams: { reason: 'missing-token' },
      });

      this.isLoading.set(false);
    }
  }

  private getCaseStatus() {
    this.feedbackService
      .getCaseStatus(this.caseToken())
      .pipe(
        tap(res => {
          this.caseStatus = res.eventStatus;
          this.isLoading.set(false);
          if (res.eventStatus) {
            this.showRatingForm.set(true);
          } else {
            this.showRatingForm.set(false);
          }
        }),
        catchError(err => {
          this.showRatingForm.set(false);
          this.errorMessage.set(err?.error.errors?.[0]?.params?.[0]);
          this.isLoading.set(false);
          return of(null);
        })
      )
      .subscribe();
  }
}
